import Store from 'store/store';

// get distance betwen two fingers for a touch event
export const getFingerDistance = (event) => {
	const X1 = event.touches[0].clientX;
	const Y1 = event.touches[0].clientY;
	const X2 = event.touches[1].clientX;
	const Y2 = event.touches[1].clientY;
	return Math.sqrt((X2 - X1) * (X2 - X1) + (Y2 - Y1) * (Y2 - Y1));
};

export const getAssetsToLoad = (habitatNum, activeHabitatData) => {
	if (!habitatNum) return [];

	const assets = {
		1: ['model', 'env', 'paper', 'hotspotSprite', 'gridTexture'],
		2: ['model', 'env', 'paper', 'hotspotSprite', 'gridTexture'],
		3: ['model', 'env', 'paper', 'hotspotSprite', 'gridTexture'],
		4: ['model', 'env', 'paper', 'hotspotSprite', 'gridTexture']
	};

	if (!activeHabitatData) {
		activeHabitatData = Store.get().appData?.pages?.main?.data?.habitats[habitatNum];
	}

	const neededHotspots = activeHabitatData.hotspots || {};
	Object.values(neededHotspots).forEach((hotspot) => {
		assets[habitatNum].push(`texture_${hotspot.name}`);
	});

	return assets[habitatNum];
};

export const habitatModelOptions = {
	initialScale: 0.5,
	hotspotOpenScale: 0.3,
	minScale: 0.2,
	maxScale: 1.3,
};

export const cameraOptions = {
	initialY: 15,
	initialZ: 15
};

export const gridOptions = {
	initialScale: 12,
};